const getHomeLink = (auth) => {

  if (auth?.user?.user_type === 'Admin') {
    return '/clients';
  } else if (auth?.user?.user_type === 'Agent') {
    return '/overview';
  }

  return '/';
};

export default getHomeLink;